import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useExhibitorAuthContext } from '../../../Context/AuthContex/ExhibitorAuthContext';
import { Button } from 'react-bootstrap';
import Toaster from '../../../Components/Toaster/Toaster';
import Loader from '../../../Components/Spinner/Loader';
import InputField from '../../../Components/Common/InputField';
import CommonImageUpload from '../../../Components/Common/CommonImageUpload';
import CommonImageAiUpload from '../../../Components/Common/CommonImageAiUpload';
import CommonTouchFieldForEdit from '../../../Components/Common/CommonTouchFieldForEdit';
import UpdateDataApi from '../../../Components/Common/FetchData/UpdateDataApi';
import { error } from 'console';

const EditProfile = ({
  setToggle,
}: {
  setToggle: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const {
    state: { exhibitorUser },
  } = useExhibitorAuthContext();
  const Toast = Toaster();
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    setValue,
    getValues,
    formState: { dirtyFields, errors },
    reset,
  } = useForm();

  const { updateData, loading, success } = UpdateDataApi(
    '/api/fair/member/update/fair-member-company-information'
  );

  useEffect(() => {
    if (success) {
      reset();
      setToggle(false);
    }
  }, [success]);
  const onSubmit = async (data: any) => {
    const formData = new FormData();
    const currentValues = getValues();
    const editFields = CommonTouchFieldForEdit({
      currentValues,
      dirtyFields,
      existingValues: { ...exhibitorUser },
    });
    if (editFields && !Object?.keys(editFields)?.length) {
      return Toast.fire({
        icon: 'error',
        title: 'Change field first',
      });
    } else {
      Object.keys(editFields).forEach((item) => {
        if (item === 'user_fair_member_company_logo') {
          formData.append(item, currentValues[item][0]);
        } else if (item === 'user_fair_member_company_logo_ai') {
          formData.append(item, currentValues[item][0]);
        } else {
          formData.append(item, currentValues[item]);
        }
      });
      updateData(formData);
    }
  };

  return (
    <section className='panel'>
      <div className='panel-body bio-graph-info'>
        <form
          className='form-horizontal'
          method='post'
          id='editProfile'
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className='profile-right-side px-3 py-3 mb-2'>
            <h4 className='profile-title'>Company Information</h4>
            <div className='row'>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
                <InputField
                  label='Company Name'
                  register={register('user_fair_member_company_name')}
                  defaultValue={
                    exhibitorUser?.user_fair_member_company_name as string
                  }
                  placeholder='Company Name'
                />
              </div>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
                <InputField
                  label='Company Email'
                  register={register('user_fair_member_company_email')}
                  defaultValue={
                    exhibitorUser?.user_fair_member_company_email as string
                  }
                  disabled
                  placeholder='Company Email'
                />
              </div>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
                <InputField
                  label='Phone'
                  register={register('user_fair_member_company_telephone')}
                  defaultValue={
                    exhibitorUser?.user_fair_member_company_telephone as string
                  }
                  placeholder='Company Phone'
                />
              </div>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
                <InputField
                  label='City Name'
                  register={register('user_fair_member_company_city')}
                  defaultValue={
                    exhibitorUser?.user_fair_member_company_city as string
                  }
                  placeholder='City Name'
                />
              </div>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
                <InputField
                  label='Zip Code'
                  register={register('user_fair_member_company_zip')}
                  defaultValue={
                    exhibitorUser?.user_fair_member_company_zip as string
                  }
                  placeholder='zip code'
                />
              </div>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
                <InputField
                  label='Company Address'
                  register={register('user_fair_member_company_address')}
                  defaultValue={
                    exhibitorUser?.user_fair_member_company_address as string
                  }
                  placeholder='Web Address'
                />
              </div>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
                <InputField
                  label='Web Address'
                  register={register('user_fair_member_company_website')}
                  defaultValue={
                    exhibitorUser?.user_fair_member_company_website as string
                  }
                  placeholder='Web Address'
                />
              </div>

              <div className='row'>
                <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
                  <CommonImageUpload
                    register={register}
                    setError={setError}
                    clearErrors={clearErrors}
                    setValue={setValue}
                    errors={errors}
                    label='Company Logo'
                    fileName='user_fair_member_company_logo'
                    defaultValue={
                      exhibitorUser?.user_fair_member_company_logo as string
                    }
                  />
                </div>
                {/* <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
                  <CommonImageAiUpload
                    fileName='user_fair_member_company_logo_ai'
                    register={register}
                    label='Company Logo(ai)'
                  />
                </div>{' '} */}
              </div>
            </div>
          </div>
          {/* <div className='profile-right-side px-3 py-3 mb-2'>
            <h4 className='profile-title'>Contact Person</h4>
            <div className='row'>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
                <InputField
                  label='Contact Name'
                  register={register('user_fair_member_contact_name')}
                  defaultValue={
                    exhibitorUser?.user_fair_member_contact_name as string
                  }
                  placeholder='Contact Name'
                />
              </div>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
                <InputField
                  label='Designation'
                  register={register('user_fair_member_contact_designation')}
                  defaultValue={
                    exhibitorUser?.user_fair_member_contact_designation as string
                  }
                  placeholder='designation'
                />
              </div>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
                <InputField
                  label='Contact No'
                  register={register('user_fair_member_contact_number')}
                  defaultValue={
                    exhibitorUser?.user_fair_member_contact_number as string
                  }
                  placeholder='contact number'
                />
              </div>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6'>
                <InputField
                  label='Email'
                  register={register('user_fair_member_contact_email')}
                  defaultValue={
                    exhibitorUser?.user_fair_member_contact_email as string
                  }
                  placeholder='email'
                />
              </div>
            </div>
          </div> */}

          <div>
            {loading ? (
              <Loader css={'w-100 mt-2 submit-button'} />
            ) : (
              <Button className='w-100 mt-2 submit-button' type='submit'>
                Update
              </Button>
            )}
          </div>
        </form>
      </div>
    </section>
  );
};

export default EditProfile;
